module.exports = __webpack_public_path__ + "static/media/file.89af29fb.svg";